import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { useT } from "@/lib/i18n";
import LangSwitcher from "@/components/LangSwitcher";
import RatchetLogo from "@/components/RatchetLogo";

export default function MarketingNav() {
  const { user } = useAuth();
  const t = useT();
  return (
    <header className="sticky top-0 z-40 w-full border-b border-white/5 bg-black/60 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2 group" data-testid="brand-logo">
          <RatchetLogo size={28} />
          <span className="font-display font-black text-lg tracking-tight">RATCHET</span>
          <span className="overline ml-1 text-[10px]">/devtool</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm">
          <Link to="/" className="text-white/70 hover:text-white transition-colors" data-testid="nav-home">{t("nav.product")}</Link>
          <Link to="/pricing" className="text-white/70 hover:text-white transition-colors" data-testid="nav-pricing">{t("nav.pricing")}</Link>
          <Link to="/demo" className="text-white/70 hover:text-white transition-colors" data-testid="nav-demo">{t("nav.demo")}</Link>
          <Link to="/about" className="text-white/70 hover:text-white transition-colors" data-testid="nav-about">{t("nav.about")}</Link>
          <Link to="/partners" className="text-white/70 hover:text-white transition-colors" data-testid="nav-partners">{t("nav.partners")}</Link>
          <Link to="/blog" className="text-white/70 hover:text-white transition-colors" data-testid="nav-blog">Blog</Link>
          <Link to="/integrations" className="text-white/70 hover:text-white transition-colors" data-testid="nav-integrations">{t("nav.integrations")}</Link>
        </nav>
        <div className="flex items-center gap-3">
          <LangSwitcher />
          {user ? (
            <Link to="/app" className="btn-primary text-sm py-2 px-4" data-testid="nav-dashboard">{t("nav.dashboard")}</Link>
          ) : (
            <>
              <Link to="/login" className="text-sm text-white/70 hover:text-white" data-testid="nav-login">{t("nav.signin")}</Link>
              <Link to="/signup" className="btn-primary text-sm py-2 px-4" data-testid="nav-signup">{t("nav.signup")}</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
